module.exports = __webpack_public_path__ + "media/main_cards/employment_contract-83f69ddb.svg";